import axios from 'axios';


export default axios.create({
    baseURL: 'https://colovr.com/'
});

//baseURL: 'https://' + (window.location.hostname === 'localhost' ? 'esd.' : '') + 'colovr.com/'